const NETWORKS_PROD = [
  {
    id: 1,
    name: 'Ethereum',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.eqhub.eqbr.com/wallets/currency/7d852a78bf5d9363fe5f57f9d56ca498169b4a261669976994569.png',
    symbol: 'ETH',
  },
  {
    id: 97,
    name: 'BSC Testnet',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.eqhub.eqbr.com/wallets/currency/7deb6ff58870072405c0418d85501c4521c3296e33ef58452be98e4ca592ed19.png',
    symbol: 'BNB',
  },
  {
    id: 43114,
    name: 'BSC Testnet',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.dev.eqhub.eqbr.com/wallets/currency/01_%EC%95%84%EB%B0%9C%EB%9E%80%EC%B2%B4.png',
    symbol: 'AVAX',
  },
  {
    id: 43161,
    name: 'EQBR',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.eqhub.eqbr.com/wallets/currency/e5c6cd4f2b18dac2d1124bf3b2b9559c99c379e21712295135135.png',
    symbol: 'EQBR',
  },
  {
    id: 43113,
    name: 'Fuji testnet (Avalanche)',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.dev.eqhub.eqbr.com/wallets/currency/01_%EC%95%84%EB%B0%9C%EB%9E%80%EC%B2%B4.png',
    symbol: 'AVAX (Fuji)',
  },
  {
    id: 144002,
    name: 'XRPL EVM Sidechain Devnet',
    symbol: 'eXRP',
    image: 'https://s3.ap-northeast-2.amazonaws.com/image.eqhub.eqbr.com/wallets/currency/xrpl.png',
  },
] as const;

const NETWORK_FEATURE = [
  {
    id: 5347,
    name: 'EQ Hub network',
    symbol: 'EQBR',
    image: '',
  },
] as const;

const getNetwork = () => {
  switch (process.env.REACT_APP_ENVIRONMENT) {
    // case 'PROD':
    //   return NETWORKS_PROD;
    // case 'FEATURE':
    //   return NETWORK_FEATURE;
    default:
      return NETWORKS_PROD;
  }
};

export const NETWORKS = getNetwork();
